import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import EditDisabledWorkerModal from '../components/EditDisabledWorkerModal';
import DisabledWorkerBulkUpdateModal from '../components/DisabledWorkerBulkUpdateModal';

const baseStyles = {
  filtersContainer: {
    background: '#f8f9fa',
    padding: '15px',
    borderRadius: '5px',
    borderBottom: '1px solid #dee2e6',
  },
  filterGroup: { display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'flex-end' },
  filterItem: { display: 'flex', flexDirection: 'column', gap: '5px' },
  filterLabel: { fontSize: '0.8rem', fontWeight: 'bold', color: '#555', paddingLeft: '2px' },
  searchInput: { padding: '8px', fontSize: '0.9rem', width: '140px' },
  tableContainer: { marginTop: '20px', overflowX: 'auto' },
  table: { width: '100%', minWidth: '1400px', borderCollapse: 'collapse' },
  th: { border: '1px solid #ddd', padding: '8px', background: '#f4f4f4', textAlign: 'center', fontSize: '0.8rem' },
  td: { border: '1px solid #ddd', padding: '8px', fontSize: '0.85rem', textAlign: 'center' },
  editButton: {
    backgroundColor: '#ffc107', color: 'black', padding: '6px 14px', cursor: 'pointer',
    border: 'none', borderRadius: '4px', fontSize: '0.85rem', whiteSpace: 'nowrap', minWidth: '56px',
  },
  thManagement: { minWidth: '90px', width: '90px', whiteSpace: 'nowrap' },
  searchButton: { backgroundColor: '#007bff', color: 'white', padding: '8px 16px', cursor: 'pointer', border: 'none', borderRadius: '4px' },
  countDisplay: { fontSize: '1rem', fontWeight: 'bold', color: '#333', marginTop: '15px', paddingLeft: '5px' },
};

const K = {
  title: '\uc7a5\uc560\uc778 \uba85\ub2e8 \uad00\ub9ac',
  year: '\uc5f0\ub3c4',
  disabledStatus: '\uc7a5\uc560\uc778 \uc5ec\ubd80',
  yes: '\uc608',
  no: '\uc544\ub2c8\uc624',
  project: '\uc0ac\uc5c5\uba85',
  all: '\uc804\uccb4',
  district: '\uc74d\uba74\ub3d9',
  districtPlaceholder: '\uc74d\uba74\ub3d9 \uac80\uc0c9',
  name: '\uc131\uba85',
  namePlaceholder: '\uc131\uba85 \uac80\uc0c9',
  search: '\uac80\uc0c9',
  exportExcel: '\uc5d1\uc140 \ucd9c\ub825',
  bulkUpdate: '\uc77c\uad04 \ub4f1\ub85d',
  searching: '\uac80\uc0c9 \uc911...',
  searchedCountPrefix: '\uac80\uc0c9\ub41c \uc778\uc6d0: \ucd1d',
  personUnit: '\uba85',
  loading: '\ub85c\ub529 \uc911...',
  index: '\uc5f0\ubc88',
  companyName: '\uc0ac\uc5c5\uc7a5\uba85',
  businessNumber: '\uc0ac\uc5c5\uc790\ub4f1\ub85d\ubc88\ud638',
  workerName: '\uc7a5\uc560\uc778\uadfc\ub85c\uc790\uba85',
  rrn: '\uc8fc\ubbfc\ub4f1\ub85d\ubc88\ud638',
  recognitionType: '\uc7a5\uc560\uc778\uc815\uad6c\ubd84',
  disabilityType: '\uc7a5\uc560\uc720\ud615',
  injuryGrade: '\uc0c1\uc774\ub4f1\uae09',
  severity: '\uc911\uc99d(\uacbd\uc99d) \uc5ec\ubd80',
  severeDouble: '\uc911\uc99d 2\ubc30\uc218 \uc778\uc815',
  recognitionDate: '\uc7a5\uc560\uc778\uc815\uc77c',
  startDate: '\uc785\uc0ac\uc77c',
  endDate: '\ud1f4\uc0ac\uc77c',
  duty: '\uadfc\ubb34 \uc9c1\ubb34',
  wage: '\uc784\uae08(\uc6d0)',
  management: '\uad00\ub9ac',
  edit: '\uc218\uc815',
  loadProjectFail: '\uc0ac\uc5c5 \ubaa9\ub85d \ub85c\ub529 \uc2e4\ud328',
  rosterLoadFail: '\uc7a5\uc560\uc778 \uba85\ub2e8 \uc870\ud68c \uc2e4\ud328',
  saveOk: '\uc800\uc7a5\ub418\uc5c8\uc2b5\ub2c8\ub2e4.',
  saveFail: '\uc800\uc7a5 \uc2e4\ud328',
  noDataToExport: '\ucd9c\ub825\ud560 \ub370\uc774\ud130\uac00 \uc5c6\uc2b5\ub2c8\ub2e4. \uba3c\uc800 \uac80\uc0c9\ud574 \uc8fc\uc138\uc694.',
  exportOk: '\uc5d1\uc140 \ud30c\uc77c\uc774 \ub2e4\uc6b4\ub85c\ub4dc\ub418\uc5c8\uc2b5\ub2c8\ub2e4.',
  exportFail: '\uc5d1\uc140 \ucd9c\ub825\uc5d0 \uc2e4\ud328\ud588\uc2b5\ub2c8\ub2e4.',
  bulkOk: '\uc77c\uad04 \ub4f1\ub85d\uc774 \uc644\ub8cc\ub418\uc5c8\uc2b5\ub2c8\ub2e4.',
  disabledLaw: '\uc7a5\uc560\uc778\ubcf5\uc9c0\ubc95',
  veteran: '\uad6d\uac00\uc720\uacf5\uc790',
};

const DisabledWorkerRosterPage = () => {
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [disabledStatus, setDisabledStatus] = useState('yes');
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState('');
  const [searchDistrict, setSearchDistrict] = useState('');
  const [searchName, setSearchName] = useState('');
  const [list, setList] = useState([]);
  const [companyName, setCompanyName] = useState('');
  const [businessNumber, setBusinessNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [hasSearched, setHasSearched] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [bulkModalOpen, setBulkModalOpen] = useState(false);

  const fetchProjects = useCallback(async () => {
    if (!selectedYear) return;
    try {
      const res = await api.get(`/projects?year=${selectedYear}`);
      setProjects(res.data || []);
      if (!selectedProject) setSelectedProject('');
    } catch (err) {
      console.error(K.loadProjectFail, err);
    }
  }, [selectedYear]);

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  const fetchRoster = useCallback(async () => {
    setLoading(true);
    setError('');
    const params = new URLSearchParams();
    params.append('year', selectedYear);
    params.append('disabledStatus', disabledStatus);
    if (selectedProject && selectedProject !== 'all' && selectedProject !== '') params.append('projectId', selectedProject);
    if (searchDistrict) params.append('district', searchDistrict);
    if (searchName) params.append('name', searchName);
    try {
      const res = await api.get(`/disabled-workers/roster?${params.toString()}`);
      setList(res.data.list || []);
      setCompanyName(res.data.companyName || '');
      setBusinessNumber(res.data.businessNumber || '');
    } catch (err) {
      setError(err.response?.data?.message || K.rosterLoadFail);
    } finally {
      setLoading(false);
    }
  }, [selectedYear, selectedProject, searchDistrict, searchName, disabledStatus]);

  useEffect(() => {
    if (hasSearched) fetchRoster();
  }, [fetchRoster, hasSearched]);

  const handleSearchClick = () => {
    setHasSearched(true);
  };

  const handleEditClick = (row) => {
    setEditingRow(row);
    setModalOpen(true);
  };

  const handleModalSave = async (participantId, data) => {
    try {
      await api.put(`/disabled-workers/${participantId}`, data);
      setMessage(K.saveOk);
      setModalOpen(false);
      setEditingRow(null);
      fetchRoster();
    } catch (err) {
      setError(err.response?.data?.message || K.saveFail);
    }
  };

  const handleExportExcel = async () => {
    if (list.length === 0) {
      setError(K.noDataToExport);
      return;
    }
    setError('');
    const params = new URLSearchParams();
    params.append('year', selectedYear);
    params.append('disabledStatus', disabledStatus);
    if (selectedProject && selectedProject !== 'all' && selectedProject !== '') params.append('projectId', selectedProject);
    if (searchDistrict) params.append('district', searchDistrict);
    if (searchName) params.append('name', searchName);
    try {
      const res = await api.get(`/disabled-workers/export?${params.toString()}`, { responseType: 'blob' });
      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', `disabled_worker_roster_${selectedYear}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
      setMessage(K.exportOk);
    } catch (err) {
      let msg = K.exportFail;
      if (err.response?.data instanceof Blob) {
        try {
          const text = await err.response.data.text();
          const json = JSON.parse(text);
          msg = json.message || msg;
        } catch (_) {}
      } else if (err.response?.data?.message) {
        msg = err.response.data.message;
      }
      setError(msg);
    }
  };

  const formatYyyyMmDd = (v) => {
    if (!v) return '';
    const s = String(v);
    if (s.length >= 8) return `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}`;
    return s;
  };

  const getLabel = (options, value) => options.find((o) => o.value === value)?.label || value || '';

  const DISABILITY_RECOGNITION_OPTIONS = [
    { value: '1', label: K.disabledLaw },
    { value: '2', label: K.veteran },
  ];

  const DISABILITY_TYPE_OPTIONS = [
    { value: '1', label: '\uc9c0\uccb4\uc7a5\uc560' }, { value: '2', label: '\ub1cc\ubcd1\ubcc0\uc7a5\uc560' }, { value: '3', label: '\uc2dc\uac01\uc7a5\uc560' },
    { value: '4', label: '\uccad\uac01\uc7a5\uc560' }, { value: '5', label: '\uc5b8\uc5b4\uc7a5\uc560' }, { value: '6', label: '\uc9c0\uc801\uc7a5\uc560' },
    { value: '7', label: '\uc815\uc2e0\uc7a5\uc560' }, { value: '8', label: '\uc790\ud3d0\uc131\uc7a5\uc560' }, { value: '9', label: '\uc2e0\uc7a5\uc7a5\uc560' },
    { value: '10', label: '\uc2ec\uc7a5\uc7a5\uc560' }, { value: '11', label: '\ud638\ud761\uae30\uc7a5\uc560' }, { value: '12', label: '\uac04\uc7a5\uc560' },
    { value: '13', label: '\uc548\uba74\uc7a5\uc560' }, { value: '14', label: '\uc7a5\ub8e8/\uc694\ub8e8\uc7a5\uc560' }, { value: '15', label: '\ub1cc\uc804\uc99d\uc7a5\uc560' },
    { value: '16', label: '\uad6d\uac00\uc720\uacf5\uc790(\ubcf4\ud6c8\ubcf4\uc0c1\ub300\uc0c1\uc790)' },
  ];

  const SEVERITY_OPTIONS = [
    { value: '1', label: '\uc911\uc99d\uc7a5\uc560\uc778' },
    { value: '2', label: '\uacbd\uc99d\uc7a5\uc560\uc778' },
  ];

  const JOB_DUTY_OPTIONS = [
    { value: '1', label: '\uad00\ub9ac\uc790' }, { value: '2', label: '\uc804\ubb38\uac00 \ubc0f \uad00\ub828\uc885\uc0ac\uc790' }, { value: '3', label: '\uc0ac\ubb34\uc885\uc0ac\uc790' },
    { value: '4', label: '\uc11c\ube44\uc2a4\uc885\uc0ac\uc790' }, { value: '5', label: '\ud310\ub9e4\uc885\uc0ac\uc790' }, { value: '6', label: '\ub18d\ub9bc\uc5b4\uc5c5 \uc219\ub828\uc885\uc0ac\uc790' },
    { value: '7', label: '\uae30\ub2a5\uc6d0 \ubc0f \uad00\ub828\uae30\ub2a5\uc885\uc0ac\uc790' }, { value: '8', label: '\uc7a5\uce58/\uae30\uacc4\uc870\uc791 \ubc0f \uc870\ub9bd\uc885\uc0ac\uc790' },
    { value: '9', label: '\ub2e8\uc21c\ub178\ubb34\uc885\uc0ac\uc790' },
  ];

  const formatJobDuty = (value) => {
    const opt = JOB_DUTY_OPTIONS.find((o) => o.value === value);
    if (!opt) return value || '';
    return `${opt.value}(${opt.label})`;
  };

  return (
    <div>
      <h2>{K.title}</h2>

      <div style={baseStyles.filtersContainer}>
        <div style={baseStyles.filterGroup}>
          <div style={baseStyles.filterItem}>
            <span style={baseStyles.filterLabel}>{K.year}</span>
            <input
              type="number"
              style={baseStyles.searchInput}
              value={selectedYear}
              onChange={(e) => setSelectedYear(parseInt(e.target.value, 10) || selectedYear)}
              min="2020"
            />
          </div>
          <div style={baseStyles.filterItem}>
            <span style={baseStyles.filterLabel}>{K.disabledStatus}</span>
            <select style={baseStyles.searchInput} value={disabledStatus} onChange={(e) => setDisabledStatus(e.target.value)}>
              <option value="yes">{K.yes}</option>
              <option value="no">{K.no}</option>
            </select>
          </div>
          <div style={baseStyles.filterItem}>
            <span style={baseStyles.filterLabel}>{K.project}</span>
            <select style={baseStyles.searchInput} value={selectedProject} onChange={(e) => setSelectedProject(e.target.value)}>
              <option value="">{`-- ${K.all} --`}</option>
              <option value="all">{K.all}</option>
              {projects.map((p) => (
                <option key={p.id} value={p.id}>{p.projectName}</option>
              ))}
            </select>
          </div>
          <div style={baseStyles.filterItem}>
            <span style={baseStyles.filterLabel}>{K.district}</span>
            <input
              type="text"
              placeholder={K.districtPlaceholder}
              value={searchDistrict}
              onChange={(e) => setSearchDistrict(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSearchClick()}
              style={baseStyles.searchInput}
            />
          </div>
          <div style={baseStyles.filterItem}>
            <span style={baseStyles.filterLabel}>{K.name}</span>
            <input
              type="text"
              placeholder={K.namePlaceholder}
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSearchClick()}
              style={baseStyles.searchInput}
            />
          </div>
          <div style={baseStyles.filterItem}>
            <button style={baseStyles.searchButton} onClick={handleSearchClick} disabled={loading}>
              {K.search}
            </button>
          </div>
          <div style={baseStyles.filterItem}>
            <button
              style={{ ...baseStyles.searchButton, backgroundColor: '#28a745' }}
              onClick={handleExportExcel}
              disabled={loading || list.length === 0}
            >
              {K.exportExcel}
            </button>
          </div>
          <div style={baseStyles.filterItem}>
            <button
              style={{ ...baseStyles.searchButton, backgroundColor: '#17a2b8' }}
              onClick={() => setBulkModalOpen(true)}
              disabled={loading}
            >
              {K.bulkUpdate}
            </button>
          </div>
        </div>
        <div style={baseStyles.countDisplay}>
          {loading ? K.searching : `${K.searchedCountPrefix} ${list.length} ${K.personUnit}`}
        </div>
      </div>

      {message && <p style={{ color: 'green', marginTop: 10 }}>{message}</p>}
      {error && <p style={{ color: 'red', marginTop: 10 }}>{error}</p>}

      <div style={baseStyles.tableContainer}>
        {loading ? (
          <p>{K.loading}</p>
        ) : (
          <table style={baseStyles.table}>
            <thead>
              <tr>
                <th style={baseStyles.th}>{K.index}</th>
                <th style={{ ...baseStyles.th, display: 'none' }}>{K.companyName}</th>
                <th style={{ ...baseStyles.th, display: 'none' }}>{K.businessNumber}</th>
                <th style={baseStyles.th}>{K.workerName}</th>
                <th style={baseStyles.th}>{K.rrn}</th>
                <th style={baseStyles.th}>{K.recognitionType}</th>
                <th style={baseStyles.th}>{K.disabilityType}</th>
                <th style={baseStyles.th}>{K.injuryGrade}</th>
                <th style={baseStyles.th}>{K.severity}</th>
                <th style={baseStyles.th}>{K.severeDouble}</th>
                <th style={baseStyles.th}>{K.recognitionDate}</th>
                <th style={baseStyles.th}>{K.startDate}</th>
                <th style={baseStyles.th}>{K.endDate}</th>
                <th style={baseStyles.th}>{K.duty}</th>
                <th style={baseStyles.th}>{K.wage}</th>
                <th style={{ ...baseStyles.th, ...baseStyles.thManagement }}>{K.management}</th>
              </tr>
            </thead>
            <tbody>
              {list.map((row) => (
                <tr key={row.participantId}>
                  <td style={baseStyles.td}>{row.index}</td>
                  <td style={{ ...baseStyles.td, display: 'none' }}>{row.companyName || row.projectName}</td>
                  <td style={{ ...baseStyles.td, display: 'none' }}>{row.businessNumber}</td>
                  <td style={baseStyles.td}>{row.name}</td>
                  <td style={baseStyles.td}>{row.rrn}</td>
                  <td style={baseStyles.td}>{getLabel(DISABILITY_RECOGNITION_OPTIONS, row.disabilityRecognitionType)}</td>
                  <td style={baseStyles.td}>{getLabel(DISABILITY_TYPE_OPTIONS, row.disabilityType)}</td>
                  <td style={baseStyles.td}>{row.injuryGrade}</td>
                  <td style={baseStyles.td}>{getLabel(SEVERITY_OPTIONS, row.severityStatus)}</td>
                  <td style={baseStyles.td}>{row.severeDoubleCountEligible || ''}</td>
                  <td style={baseStyles.td}>{formatYyyyMmDd(row.disabilityRecognitionDate)}</td>
                  <td style={baseStyles.td}>{formatYyyyMmDd(row.employmentStartDate)}</td>
                  <td style={baseStyles.td}>{formatYyyyMmDd(row.employmentEndDate)}</td>
                  <td style={baseStyles.td}>{formatJobDuty(row.jobDuty)}</td>
                  <td style={baseStyles.td}>{row.wage != null ? Number(row.wage).toLocaleString() : ''}</td>
                  <td style={{ ...baseStyles.td, ...baseStyles.thManagement }}>
                    <button style={baseStyles.editButton} onClick={() => handleEditClick(row)}>
                      {K.edit}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <EditDisabledWorkerModal
        row={editingRow}
        isOpen={modalOpen}
        onClose={() => { setModalOpen(false); setEditingRow(null); }}
        onSave={handleModalSave}
        disabilityRecognitionOptions={DISABILITY_RECOGNITION_OPTIONS}
        disabilityTypeOptions={DISABILITY_TYPE_OPTIONS}
        severityOptions={SEVERITY_OPTIONS}
        jobDutyOptions={JOB_DUTY_OPTIONS}
      />

      <DisabledWorkerBulkUpdateModal
        isOpen={bulkModalOpen}
        onClose={() => setBulkModalOpen(false)}
        onSuccess={() => { setMessage(K.bulkOk); fetchRoster(); }}
        selectedYear={selectedYear}
      />
    </div>
  );
};

export default DisabledWorkerRosterPage;
